import { useCallback } from "react";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { INLegsSearchParam } from "../../Interfaces/nLegsInterfaces";
import {
  getNLegsOrderFilterOptions,
  getNLegsTradeFilterOptions,
  getNLegsErrorFilterOptions,
  getOffsetTypes,
} from "../../Requests/nLegsRequests";
import OrderTableFilters from "../shared/OrderTableFilters";

export type NLegsFilterMode = "order" | "trade" | "errors";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: INLegsSearchParam;
  legCount: number;
  mode: NLegsFilterMode;
}

const getFilterOptionsByMode = {
  order: getNLegsOrderFilterOptions,
  trade: getNLegsTradeFilterOptions,
  errors: getNLegsErrorFilterOptions,
};

export default function SearchParamBox({ onChange, searchParam, legCount, mode }: IProps) {
  const getFilterOptions = useCallback(
    () => getFilterOptionsByMode[mode]({ searchParam, legCount }),
    [mode, searchParam, legCount],
  );
  return (
    <div className="flex flex-row justify-start items-center gap-3">
      <OrderTableFilters getFilterOptions={getFilterOptions} searchParam={searchParam}
        accountField="sahraUserId" onChange={onChange} />
      {mode === "order" ? (
        <div className="w-48">
          <DynamicDropdown
            dropdown={{ name: "optionOrderTypes", placeholder: "نوع offset" }}
            inputId={legCount}
            getData={() => getOffsetTypes(legCount)}
            value={searchParam.optionOrderTypes?.join(",")}
            onChange={(name, value) => onChange(name, value == null ? null : String(value).split(",").map(Number))}
          />
        </div>
      ) : null}
    </div>
  );
}
